import React from 'react';

import './Evolution.scss';

import arrowUp from '../../assets/img/arrow/arrow-up.svg';
import arrowDown from '../../assets/img/arrow/arrow-down.svg';
import arrowNeutral from '../../assets/img/arrow/arrow-neutral.svg';

export interface IEvolution {
  arrow: number;
  price: number;
  origin: string;
  currency: string;
  decimals?: number;
}

export default function Evolution({
  arrow,
  price,
  origin,
  currency,
  decimals,
}: IEvolution): JSX.Element {
  let arrowSvg: string;

  if (arrow === 0) {
    arrowSvg = arrowNeutral;
  } else if (arrow > 0) {
    arrowSvg = arrowUp;
  } else {
    arrowSvg = arrowDown;
  }
  return (
    <div className="Evolution">
      <div className="Evolution__value">
        <div className="Evolution__arrow">
          <img src={arrowSvg} alt="" />
        </div>
        <div className="Evolution__price">{price ? price.toFixed(decimals) : '...'}</div>
      </div>
      <div className="Evolution__supplements">
        <div className="Evolution__origin">{origin}</div>
        <div className="Evolution__currency">{currency}</div>
      </div>
    </div>
  );
}

Evolution.defaultProps = {
  decimals: 2,
};
